var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ user_avatar: true, text_head: !_vm.src },style:(_vm.lineHeight
      ? {
          lineHeight: _vm.lineHeight + 'px',
          height: _vm.lineHeight + 'px',
          width: _vm.lineHeight + 'px'
        }
      : {})},[(_vm.src)?_c('base-img',{attrs:{"fit":"fill","src":_vm.src}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"placeholder"},slot:"placeholder"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_vm._v(_vm._s(_vm.name))])]):_c('span',{staticClass:"textPhoto",style:(_vm.lineHeight == 20 ? ' font-size: 10px!important;' : '')},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }